module.exports = __webpack_public_path__ + "img/expenses.69095e10.png";